export const recentPurchasers = [
  { name: 'María Fernanda', city: 'Buenos Aires' },
  { name: 'Camila', city: 'Santiago' },
  { name: 'Valentina', city: 'Bogotá' },
  { name: 'Sofía', city: 'Ciudad de México' },
  { name: 'Isabella', city: 'Lima' },
  { name: 'Lucía', city: 'Córdoba' },
  { name: 'Martina', city: 'Montevideo' },
  { name: 'Gabriela', city: 'Quito' },
  { name: 'Ana Paula', city: 'Asunción' },
  { name: 'Carolina', city: 'Medellín' },
  { name: 'Renata', city: 'Guadalajara' },
  { name: 'Daniela', city: 'Rosario' },
  { name: 'Paula', city: 'Valparaíso' },
  { name: 'Elena', city: 'Cali' },
  { name: 'Victoria', city: 'Monterrey' },
]

export const getRandomPurchaser = () => {
  const randomIndex = Math.floor(Math.random() * recentPurchasers.length)
  return recentPurchasers[randomIndex]
}
